module.exports = __webpack_public_path__ + "img/game3.0b8fa725.png";